<template>
  <div class="expert-detail">
    <div class="top-box">
      <div class="avatar-box">
        <img :src="userinfo.poster" class="avatar" alt="" />
      </div>
      <div class="top-box-content">
        <div class="username">{{userinfo.name}}</div>
        <div class="row-wrap">
          <div class="row-item">
            <div class="row">
              <div class="row-lab">专业特长:</div>
              <div class="row-con">{{userinfo.skill}}</div>
            </div>
          </div>
          <div class="row-item">
            <div class="row">
              <div class="row-lab">职称:</div>
              <div class="row-con">{{userinfo.title}}</div>
            </div>
          </div>
          <div class="row-item">
            <div class="row">
              <div class="row-lab">大学名称:</div>
              <div class="row-con">{{userinfo.school}}</div>
            </div>
          </div>
          <div class="row-item">
            <div class="row">
              <div class="row-lab">所在地区:</div>
              <div class="row-con">{{userinfo.province}}</div>
            </div>
          </div>
          <div class="row-item">
            <div class="row">
              <div class="row-lab">主要论著:</div>
              <div class="row-con">{{userinfo.works}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-wrap">
      <div class="title-box">
        <div class="title">人物简介</div>
      </div>
      <div class="content"  >{{userinfo.introduction}}</div>
    </div>
     <div class="box-wrap">
      <div class="title-box">
        <div class="title">代表成果</div>
      </div>
      <div class="content" v-html="userinfo.experience"  ></div>
    </div>
  </div>
</template>

<script>
import {handRichtext} from '@/utils/tools'
  export default {
    name: "expert-detail",
    data() {
      return {
        userinfo:{}
      };
    },
    created() {
      this.getExpertData()
    },
    mounted() {},
    methods: {
      async getExpertData(){
        try {
          const config = {
            params:{
              id: this.$route.query.id
            },
            data:{}
          }
          const res = await this.$api.fetchExpertData(config);
          res.data.experience = handRichtext(res.data.experience)
          this.userinfo = res.data
          console.log('list',res);
        } catch (err) {
          return Promise.reject(err)
        }
      }
    },
  };
</script>

<style scoped lang="scss">
  .expert-detail {
    width: 1200px;
    margin: 0 auto;
    font-size: 15px;
    .top-box{
      display: flex;
      padding: 50px 0 ;
      .avatar-box{
        width: 200px;
        height: 290px;
        position: relative;
        z-index: 30;
        &::after{
          content: '';
          display: block;
          position: absolute;
          width: 85%;
          height: 100%;
          border: 1px solid #AB9388;
          left: -20px;
          top: 20px;
          z-index: -10;
        }
        .avatar{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .top-box-content{
        margin-left: 40px;
        flex: 1;
        .username{
          font-size: 18px;
          font-weight: bold;
          line-height: 1.8;
          margin: 30px 0 15px;
        }
        .row-wrap{
          display: flex;
          flex-wrap: wrap;
          line-height: 1.8;
          .row-item{
            width: calc(50% - 20px);
            margin-right: 20px;
            .row{
              display: flex;
              align-items: flex-start;
              .row-lab{
                width: 90px;
                color: #999999;
              }
              .row-con{
                flex: 1;
              }
            }
          }
        }
      }
    }
    .box-wrap{
      margin: 0 0 90px 0;
      .title-box{
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 24px;
        margin: 0px 0 40px 0;
        .title{
          width: 200px;
          height: 40px;
          text-align: center;
          background:url('../../../../assets/img/bg_expert.png');
          background-size: cover;
          background-repeat: no-repeat;
          line-height: 40px;


        }
      }
      .content{
        // font-size: 14px;
        line-height: 1.8;
      }
    }
  }
</style>
